module.exports = __webpack_public_path__ + "img/sports-tennis_white.644e8431.svg";